module.exports = __webpack_public_path__ + "img/EME_logo.21d094ca.svg";